import { render, staticRenderFns } from "./ServerTrialActions.vue?vue&type=template&id=2d61001e&scoped=true&"
import script from "./ServerTrialActions.vue?vue&type=script&lang=js&"
export * from "./ServerTrialActions.vue?vue&type=script&lang=js&"
import style0 from "./ServerTrialActions.vue?vue&type=style&index=0&id=2d61001e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61001e",
  null
  
)

export default component.exports